export const TABLE_DATA = {
  heading: "OneMind Kubernetes vs. Self-Managed Kubernetes",
  headers: {
    onemind: "OneMind Kubernetes ",
    otherCompanies: "Self-Managed Kubernetes",
  },
  data: [
    {
      feature: "K8s Compliance",
      onemind: "100% CNCF-compliant, upstream",
      otherCompanies: "Depends on setup",
    },
    {
      feature: "Control Plane Management",
      onemind: "Fully managed (99.99% SLA)",
      otherCompanies: "Manual installation, maintenance, upgrades",
    },
    {
      feature: "Auto-Scaling",
      onemind: "Pod + Node scaling with full policy control",
      otherCompanies: "Requires manual configuration",
    },
    {
      feature: "RBAC & Access Isolation",
      onemind: "Fine-grained RBAC, namespace isolation",
      otherCompanies: "Manual RBAC setup",
    },
    {
      feature: "Multi-Tenancy",
      onemind: "Native public cluster support with sandboxing",
      otherCompanies: "Needs manual isolation strategies",
    },
    {
      feature: "CI/CD Integration",
      onemind: "GitOps-native (ArgoCD, Flux ready)",
      otherCompanies: "Requires third-party CI/CD setup",
    },
    {
      feature: "Vendor Lock-In",
      onemind: "None — portable across any infrastructure",
      otherCompanies: "None",
    },
    {
      feature: "Deployment Flexibility",
      onemind: "Multi-cloud, hybrid, on-prem ready",
      otherCompanies: "High flexibility but high setup effort",
    },
    {
      feature: "Monitoring & Observability",
      onemind: "Built-in dashboards, logs, and alerts",
      otherCompanies: "Must deploy and manage monitoring stack",
    },
    {
      feature: "Zero Downtime Upgrades",
      onemind: "Rolling upgrades supported by default",
      otherCompanies: "Complex to implement manually",
    },
    {
      feature: "Operational Overhead",
      onemind: "Minimal — OneMind manages everything",
      otherCompanies: "High — full responsibility on internal teams",
    },
    {
      feature: "Cost Predictability",
      onemind: "Transparent pricing, no surprise fees",
      otherCompanies: "Variable costs for infra + human resources",
    },
  ],
};
